var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"d-sm-flex justify-content-between align-items-center"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('b-button',{attrs:{"variant":"light","to":{name: 'Vehicles'}}},[_vm._v("← Volver")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }